var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllContacts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8326_2039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z",
    fill: "url(#paint0_linear_8326_2039)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 2.63158,
    height: 2.63158,
    rx: 1,
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.6836,
    y: 7,
    width: 2.63158,
    height: 2.63158,
    rx: 1,
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.3672,
    y: 7,
    width: 2.63158,
    height: 2.63158,
    rx: 1,
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 10.6855,
    width: 2.63158,
    height: 2.63158,
    rx: 1,
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 14.3672,
    width: 2.63158,
    height: 2.63158,
    rx: 1,
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.6836,
    y: 10.6855,
    width: 2.63158,
    height: 2.63158,
    rx: 1,
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.6836,
    y: 14.3672,
    width: 2.63158,
    height: 2.63158,
    rx: 1,
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.3672,
    y: 10.6855,
    width: 2.63158,
    height: 2.63158,
    rx: 1,
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.3672,
    y: 14.3672,
    width: 2.63158,
    height: 2.63158,
    rx: 1,
    fill: "#E9E9E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8326_2039",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35303E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E7799"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8326_2039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllContacts);
export default __webpack_public_path__ + "static/media/all_contacts.ecc4cd74fa7f2dcc2f300e3b210729f3.svg";
export { ForwardRef as ReactComponent };